import React from 'react';

const SharingPodcastRSS = () => {
    return (
        <>
            {/*

            <a
                href="https://anchor.fm/s/eff13fac/podcast/rss"
                target="_blank"
                rel="noopener noreferrer"
            >
                https://anchor.fm/s/eff13fac/podcast/rss
            </a>
            */}

            <div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-fff text-center line-height-125per pt-20l-10s">
                Coming Soon: Sharing Podcast RSS Feed
            </div>
        </>
    );
};

export default SharingPodcastRSS;